import * as React from 'react';
import { Theme, StyleRules } from '@material-ui/core/styles';
import withStyles, { ClassNameMap } from '@material-ui/core/styles/withStyles';
import {
  Button,
  Grid,
} from '@material-ui/core';
import { Compare as CompareIcon } from '@material-ui/icons';

import SnackbarsMessage from './SnackbarsMessage';
import Uploader from './UploaderForHighlight';
import {
  UploadFileForHighlight, UploadFileState, UploadFilePattern, uploadFilePatterns,
} from '../modules/uploadForHighlight';
import fillArray from '../utils/fillArray';
import {
  ComparisonForHighlight as ComparisonTypeForHighlight,
  ComparisonStateForHighlight,
} from '../modules/comparisonHighlight';
import { userinfo } from '../services/contractApi';

interface Props {
  accept?: string[];
  files: (UploadFileForHighlight | null)[];
  fileStates: UploadFileState[];
  filePatterns: UploadFilePattern[];
  comparisonForHighlight: ComparisonTypeForHighlight | null;
  comparisonStateForHighlight: ComparisonStateForHighlight | null;
  messages: string[];
  postUpload: (index: number, file: File) => void;
  clearUploadFile: (index: number) => void;
  clearUploadMessages: () => void;
  setUploadFilePattern: (index: number, pattern: UploadFilePattern) => void;
  failUpload: (index: number, messages: string[]) => void;
  goComparisonHighlightPage: () => void;
  classes: ClassNameMap;
  status: number;
  goLoginPage: () => void;
}

interface State {
  filePattern: string[];
}

const style = (theme: Theme): StyleRules => ({
  compare: {
    marginTop: theme.spacing.unit * 3,
  },
});

class UploaderForHighlight extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      filePattern: fillArray(Array(props.files.length), uploadFilePatterns[0]),
    };
  }

  // ストア情報があれば比較結果を再表示
  componentDidMount() {
    // token生存確認
    userinfo().then((res) => {
      const { status_code } = res;
      if (status_code === 401 || status_code === 403) {
        document.cookie = 'access_token=; expires=0';
        document.cookie = 'username=; expires=0';
        this.props.goLoginPage();
      }
    });

    const { goComparisonHighlightPage } = this.props;
    if (this.props.comparisonForHighlight) {
      goComparisonHighlightPage();
    }
  }

  static defaultProps: Partial<Props> = {
    // Windowsが認識できないのでコメントアウト
    // accept: [
    //   'text/plain',
    //   'application/msword',
    //   'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    //   'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
    //   'application/vnd.ms-word.document.macroEnabled.12',
    //   'application/vnd.ms-word.template.macroEnabled.12',
    // ],
  };

  handleChangePattern = (index: number, pattern: UploadFilePattern) => {
    this.props.setUploadFilePattern(index, pattern);
  }

  handleChangeFile = (index: number, file: File) => {
    this.props.postUpload(index, file);
  }

  handleClose = () => {
    this.props.clearUploadMessages();
  }

  handleError = (index: number, error: string) => {
    this.props.failUpload(index, [error]);
  }

  render() {
    const {
      accept, files, fileStates, filePatterns, messages, classes,
      clearUploadFile, goComparisonHighlightPage, goLoginPage, status,
    } = this.props;

    // tokenチェックエラーの場合、トークンを削除し、画面遷移を発生させ、ログインページに遷移
    if (status === 403 || status === 401) {
      document.cookie = 'access_token=; expires=0';
      document.cookie = 'username=; expires=0';
      goLoginPage();
    }

    // アップロード対象を二つにする対応
    if (files.length === 3) {
      files.pop();
    }

    return (
      <React.Fragment>
        <SnackbarsMessage
          variant="error"
          messages={messages}
          onClose={this.handleClose}
        />
        <Grid
          container
          spacing={16}
        >
          {files.map((_, i) => (
            <Grid item xs key={i}>
              <Uploader
                accept={accept}
                index={i}
                file={files[i]}
                fileState={fileStates[i]}
                filePattern={filePatterns[i]}
                onChangePattern={this.handleChangePattern}
                onChangeFile={this.handleChangeFile}
                onClearFile={clearUploadFile}
                onError={this.handleError}
              />
            </Grid>
          ))}
        </Grid>
        <Grid
          container
          justify="center"
          className={classes.compare}
        >
          <Grid item>
            <Button
              disabled={files.filter(x => x).length < 2}
              variant="contained"
              color="primary"
              onClick={() => goComparisonHighlightPage()}
            >
              <CompareIcon />比較
            </Button>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

export default withStyles(style)(UploaderForHighlight);



// WEBPACK FOOTER //
// ./src/components/UploadForHighlight.tsx